/** Running from the home screen, with no browser around it. */
export function runningAsApp(): boolean {
  const iphone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return iphone || window.matchMedia("(display-mode: standalone)").matches;
}
